/**
 * Serializes Error objects to plain objects for SSR payload serialization
 *
 * XState machines that store errors in context must serialize them to avoid
 * DevalueError "Cannot stringify arbitrary non-POJOs" during SSR.
 *
 * @param error - Error object or any value
 * @returns Plain object with error properties or the original value
 */
export function serializeError(error: any) {
  if (error instanceof Error) {
    return {
      message: error.message,
      name: error.name,
      stack: error.stack,
      statusCode: (error as any).statusCode,
      response: (error as any).response,
    }
  }
  return error
}
